"use strict";

angular
    .module("internal.vehicles")
    .directive("internalVehicleHeader", [
        function() {
            return {
                restrict: "E",
                templateUrl:
                    paths.app +
                    "vehicles/components/vehicle-header/vehicle-header.html",
                controller: "InternalVehicleHeader",
                replace: true
            };
        }
    ])
    .controller("InternalVehicleHeader", [
        "$scope",
        "$filter",
        "$rootScope",
        function($scope, $filter, $rootScope) {
            $scope.getIntegrationMethods = function(services) {
                var names = "";
                var methodIDs = [];

                services.forEach(function(service) {
                    if (
                        service.integration_method != null &&
                        methodIDs[service.integration_method.id] == null &&
                        service.integration_method
                            .integration_method_type_name !=
                            "Syncing Not Applicable"
                    ) {
                        if (names == "") {
                            names = service.integration_method.name;
                        } else {
                            names += ", " + service.integration_method.name;
                        }
                        methodIDs[service.integration_method.id] = 1;
                    }
                });

                return names;
            };

            $scope.hasSyncingApplicableIntegrationMethodTypeNameFunction = function(services) {
                var hasSyncingApplicableIntegrationMethodTypeName = false;
                if ($rootScope.enterprise && $rootScope.enterprise.sync_settings && $rootScope.enterprise.sync_settings.vehicles != true) {
                    return hasSyncingApplicableIntegrationMethodTypeName;
                }
                services.forEach(function(service) {
                    if (service.integration_method != null) {
                        if (service.integration_method.integration_method_type_name !="Syncing Not Applicable" && service.integration_method.integration_method_type_name != null) {
                            hasSyncingApplicableIntegrationMethodTypeName = true;
                        }
                    }
                });
                return hasSyncingApplicableIntegrationMethodTypeName;
            };

            $scope.date30 = function() {
                var date30 = new Date();
                date30.setDate(date30.getDate() + 30);
                return date30;
            };
        }
    ]);
